import {QueryKey, useQuery, UseQueryOptions} from 'react-query';
import {useAuth0} from '@auth0/auth0-react';
import { API_URL } from 'Store/Shared/Middleware/API/Constants';

const useFetch = (
    url: string,
    params?: object,
    config?: object
) => {
    const { getAccessTokenSilently } = useAuth0();

    const fetcher = async ({
         queryKey,
         pageParam
     }: any) => {
        const [url, params] = queryKey;

        const accessToken = await getAccessTokenSilently();

        const queryUrl = new URL(url);
        if (!!params) {
            queryUrl.search = new URLSearchParams(params).toString();
        }

        const response = await fetch(
            queryUrl,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
        );

        return response?.json();
    }

    const context = useQuery(
        [API_URL+url, params],
        ({ queryKey }) => fetcher({ queryKey }),
        {
            enabled: !!url,
            ...config
        }
    )

    return context;
}

export default useFetch;